import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import { createElement } from "@uenf/layout";

export default class extends Controller {
  static targets = ["select"];
  static values = { url: String, origin: String };

  async change(e) {
    const originId = e.target.value;
    this.selectTarget.innerHTML = '';
    this.selectTarget.appendChild(createElement('option', { value: '' }));
    if (!originId) return;

    const response = await get(
      `${this.urlValue}?${this.originValue}_id=${originId}`,
      { responseKind: "json" }
    );
    if (response.ok) {
      const areasDeConcentracao = await response.json;
      for (let areaDeConcentracao of areasDeConcentracao) {
        const element = createElement(
          'option', { value: areaDeConcentracao.id }, areaDeConcentracao.nome
        );
        this.selectTarget.appendChild(element);
      }
    } else {
      console.log(`ERRO: ${response.code}`);
    }
  }
}
